import { getDataIdsFromContract } from '../../../shared/utils/dataId';

export const jobNodeRelationDataIds = getDataIdsFromContract({
  base: 'job-node-relation',
  container: '',
  source: 'source',
  dest: 'dest',
  pipelineNameTooltip: 'pipeline-name-tooltip',
  pipelineName: 'pipeline-name',
  badge: 'badge',
  modeIcon: 'mode'
});
